import React from 'react';

const WpFormStep = ({ 
    wpData, 
    wpProgression, 
    onWpDataChange, 
    onWpOwnershipChange, 
    onPrev, 
    onNext, 
    isWpStepValid,
    isWpQualified,
    isWpDisqualified 
}) => {
    const isLivingAreaUnsupported = Number(wpData.livingAreaSize) > 250;

    return (
        <div className="wp-form-step">
            <h2 className="form-title">🔥 Wärmepumpe</h2>
            
            {/* Eigentümer - Immer sichtbar als erstes Element */}
            <div className="form-section">
                <label className="form-label required">Eigentümer</label>
                <div className="yes-no-buttons">
                    <button 
                        type="button"
                        className={`yes-button ${wpData.isOwner === true ? 'selected' : ''}`}
                        onClick={() => onWpOwnershipChange(true)}
                    >
                        <div className="icon-container">
                            <svg viewBox="0 0 24 24" className="yes-icon">
                                <path 
                                    d="M4 12.6L9 17.6L20 6.6" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                />
                            </svg>
                        </div>
                        <span>Ja</span>
                    </button>
                    <button 
                        type="button"
                        className={`no-button ${wpData.isOwner === false ? 'selected' : ''}`}
                        onClick={() => onWpOwnershipChange(false)}
                    >
                        <div className="icon-container">
                            <svg viewBox="0 0 24 24" className="no-icon">
                                <path 
                                    d="M5 5L19 19M5 19L19 5" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                />
                            </svg>
                        </div>
                        <span>Nein</span>
                    </button>
                </div>
                
                {/* Qualifizierungsnachricht für Eigentümer */}
                {wpData.isOwner === false && (
                    <div className="qualification-message disqualified">
                        <svg viewBox="0 0 24 24" className="qualification-icon">
                            <path 
                                d="M5 5L19 19M5 19L19 5" 
                                fill="none" 
                                stroke="currentColor" 
                                strokeWidth="3" 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                            />
                        </svg>
                        <span>Lead nicht Qualifiziert</span>
                    </div>
                )}
            </div>
            
            {/* Gebäudeart */}
            {wpProgression >= 2 && (
                <div className="form-section">
                    <label className="form-label required">Gebäudeart</label>
                    <div className="building-type-buttons">
                        <button 
                            type="button"
                            className={`building-button ${wpData.buildingType === 'Einfamilienhaus' ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ buildingType: 'Einfamilienhaus' })}
                        >
                            <div className="building-icon">
                                <svg viewBox="0 0 100 100">
                                    <path d="M50,20 L20,45 L20,80 L80,80 L80,45 Z" fill="none" stroke="currentColor" strokeWidth="3"/>
                                    <rect x="35" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="55" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="45" y="65" width="10" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
                                </svg>
                            </div>
                            <span>Einfamilienhaus</span>
                        </button>
                        <button 
                            type="button"
                            className={`building-button ${wpData.buildingType === 'Zweifamilienhaus' ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ buildingType: 'Zweifamilienhaus' })}
                        >
                            <div className="building-icon">
                                <svg viewBox="0 0 100 100">
                                    <path d="M50,20 L15,45 L15,80 L85,80 L85,45 Z" fill="none" stroke="currentColor" strokeWidth="3"/>
                                    <line x1="50" y1="45" x2="50" y2="80" stroke="currentColor" strokeWidth="2" />
                                    <rect x="25" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="65" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="30" y="65" width="10" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="60" y="65" width="10" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
                                </svg>
                            </div>
                            <span>Zweifamilienhaus</span>
                        </button>
                        <button 
                            type="button"
                            className={`building-button ${wpData.buildingType === 'Reihenhaus' ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ buildingType: 'Reihenhaus' })}
                        >
                            <div className="building-icon">
                                <svg viewBox="0 0 100 100">
                                    <path d="M10,80 L10,45 L30,30 L30,80 Z M30,80 L30,30 L50,30 L50,80 Z M50,80 L50,30 L70,30 L70,80 Z M70,80 L70,30 L90,45 L90,80 Z" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="15" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                    <rect x="37" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                    <rect x="56" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                    <rect x="77" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                </svg>
                            </div>
                            <span>Reihenhaus</span>
                        </button>
                    </div>
                </div>
            )}
            
            {/* Wohnfläche */}
            {wpProgression >= 3 && (
                <div className="form-section">
                    <label className="form-label required">Wie groß ist die Wohnfläche Ihres Hauses?</label>
                    <input
                        type="number"
                        name="livingAreaSize"
                        value={wpData.livingAreaSize}
                        onChange={(e) => onWpDataChange({ livingAreaSize: e.target.value })}
                        className="form-input"
                        placeholder="z.B. 120"
                        required
                    />
                    {isLivingAreaUnsupported && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert - Wohnfläche über 250 qm wird nicht unterstützt</span>
                        </div>
                    )}
                </div>
            )}
            
            {/* Personen im Haus */}
            {wpProgression >= 4 && (
                <div className="form-section">
                    <label className="form-label required">Wie viele Personen Leben in Ihrem Haus?</label>
                    <input
                        type="number"
                        name="peopleInHouse"
                        value={wpData.peopleInHouse}
                        onChange={(e) => onWpDataChange({ peopleInHouse: e.target.value })}
                        className="form-input"
                        placeholder="z.B. 4"
                        required
                    />
                </div>
            )}

            {/* Baujahr */}
            {wpProgression >= 5 && (
                <div className="form-section">
                    <label className="form-label required">Wann wurde Ihr Haus gebaut?</label>
                    <input
                        type="number"
                        name="buildYear"
                        value={wpData.buildYear}
                        onChange={(e) => onWpDataChange({ buildYear: e.target.value })}
                        className="form-input"
                        placeholder="z.B. 1985"
                        required
                    />
                </div>
            )}

            {/* Gas oder Öl Heizung */}
            {wpProgression >= 6 && (
                <div className="form-section">
                    <label className="form-label required">Haben Sie eine Gas, Öl oder Wärmepumpen Heizung?</label>
                    <div className="yes-no-buttons">
                        <button 
                            type="button"
                            className={`yes-button ${wpData.hasGasOrOil === true ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ hasGasOrOil: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path 
                                        d="M4 12.6L9 17.6L20 6.6" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button 
                            type="button"
                            className={`no-button ${wpData.hasGasOrOil === false ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ hasGasOrOil: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path 
                                        d="M5 5L19 19M5 19L19 5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>
                    
                    {/* Qualifizierungsnachricht */}
                    {wpData.hasGasOrOil === false && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path 
                                    d="M5 5L19 19M5 19L19 5" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}
            
            {/* Heizungsanlage älter als 10 Jahre */}
            {wpProgression >= 7 && (
                <div className="form-section">
                    <label className="form-label required">Heizungsanlage älter als 10 Jahre?</label>
                    <div className="yes-no-buttons">
                        <button 
                            type="button"
                            className={`yes-button ${wpData.heatingOlderThan2Years === true ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ heatingOlderThan2Years: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path 
                                        d="M4 12.6L9 17.6L20 6.6" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button 
                            type="button"
                            className={`no-button ${wpData.heatingOlderThan2Years === false ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ heatingOlderThan2Years: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path 
                                        d="M5 5L19 19M5 19L19 5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>
                    
                    {/* Qualifizierungsnachricht */}
                    {wpData.heatingOlderThan2Years === false && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path 
                                    d="M5 5L19 19M5 19L19 5" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            {/* Aktuelles Wärmeabgabesystem */}
            {wpProgression >= 8 && (
                <div className="form-section">
                    <label className="form-label required">Aktuelles Wärmeabgabesystem</label>
                    <div className="radio-options">
                        <label className="radio-option">
                            <input
                                type="radio"
                                name="currentHeatingSystem"
                                value="Fußbodenheizung"
                                checked={wpData.currentHeatingSystem === "Fußbodenheizung"}
                                onChange={() => onWpDataChange({ currentHeatingSystem: "Fußbodenheizung" })}
                            />
                            <span>Fußbodenheizung</span>
                        </label>
                        <label className="radio-option">
                            <input
                                type="radio"
                                name="currentHeatingSystem"
                                value="Heizkörper"
                                checked={wpData.currentHeatingSystem === "Heizkörper"}
                                onChange={() => onWpDataChange({ currentHeatingSystem: "Heizkörper" })}
                            />
                            <span>Heizkörper</span>
                        </label>
                        <label className="radio-option">
                            <input
                                type="radio"
                                name="currentHeatingSystem"
                                value="Fußbodenheizung und Heizkörper"
                                checked={wpData.currentHeatingSystem === "Fußbodenheizung und Heizkörper"}
                                onChange={() => onWpDataChange({ currentHeatingSystem: "Fußbodenheizung und Heizkörper" })}
                            />
                            <span>Fußbodenheizung und Heizkörper</span>
                        </label>
                    </div>
                </div>
            )}
            
            {/* Solarthermieanlage */}
            {wpProgression >= 9 && (
                <div className="form-section">
                    <label className="form-label required">Haben Sie eine Solarthermieanlage?</label>
                    <div className="yes-no-buttons">
                        <button 
                            type="button"
                            className={`yes-button ${wpData.hasSolarThermal === true ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ hasSolarThermal: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path 
                                        d="M4 12.6L9 17.6L20 6.6" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button 
                            type="button"
                            className={`yes-button ${wpData.hasSolarThermal === false ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ hasSolarThermal: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path 
                                        d="M5 5L19 19M5 19L19 5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>
                </div>
            )}

            {/* Solarthermie wird abgeklemmt oder abgebaut */}
            {wpProgression >= 10 && wpData.hasSolarThermal === true && (
                <div className="form-section">
                    <label className="form-label required">Solarthermie wird abgeklemmt oder abgebaut?</label>
                    <div className="yes-no-buttons">
                        <button 
                            type="button"
                            className={`yes-button ${wpData.solarThermalRemoved === true ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ solarThermalRemoved: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path 
                                        d="M4 12.6L9 17.6L20 6.6" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button 
                            type="button"
                            className={`no-button ${wpData.solarThermalRemoved === false ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ solarThermalRemoved: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path 
                                        d="M5 5L19 19M5 19L19 5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>
                    
                    {/* Qualifizierungsnachricht */}
                    {wpData.solarThermalRemoved === false && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path 
                                    d="M5 5L19 19M5 19L19 5" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}
            
            {/* Denkmalschutz */}
            {wpProgression >= 11 && (
                <div className="form-section">
                    <label className="form-label required">Denkmalschutz</label>
                    <div className="yes-no-buttons">
                        <button 
                            type="button"
                            className={`reverse-yes-button ${wpData.hasMonumentProtection === true ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ hasMonumentProtection: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path 
                                        d="M4 12.6L9 17.6L20 6.6" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button 
                            type="button"
                            className={`reverse-no-button ${wpData.hasMonumentProtection === false ? 'selected' : ''}`}
                            onClick={() => onWpDataChange({ hasMonumentProtection: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path 
                                        d="M5 5L19 19M5 19L19 5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="3" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>
                    
                    {/* Qualifizierungsnachricht für Denkmalschutz */}
                    {wpData.hasMonumentProtection === true && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path 
                                    d="M5 5L19 19M5 19L19 5" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            {/* Zeige abschließende Qualifizierungsmeldung wenn alle erforderlichen Felder ausgefüllt sind und Lead qualifiziert ist */}
            {wpProgression >= 12 && isWpQualified() && isWpStepValid() && (
                <div className="qualification-message qualified">
                    <svg viewBox="0 0 24 24" className="qualification-icon">
                        <path 
                            d="M4 12.6L9 17.6L20 6.6" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="3" 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                        />
                    </svg>
                    <span>Der Lead ist qualifiziert!</span>
                </div>
            )}
            
            <div className="form-actions">
                <button type="button" className="prev-button" onClick={onPrev}>
                    ← Zurück zu PV
                </button>
                <button 
                    type="button" 
                    className="next-button"
                    onClick={onNext}
                    disabled={!isWpStepValid()}
                >
                    Weiter zu Kundendaten →
                </button>
            </div>
        </div>
    );
};

export default WpFormStep;